import $ from "jquery";

$(function() {
    $(".helppopup").each(function() {
        initHelpPopup($(this));
    })

    $(document).on("click", "[data-showhelp]", function() {
        const popupName = $(this).data("showhelp");
        showHelpPopup(popupName);
    });
});

function initHelpPopup($helpPopup) {
    $helpPopup.find(".closebutton").on("click", function() {
        $helpPopup.removeClass("visible");
    });
}

function showHelpPopup(popupName) {
    const $helpPopup = $(".helppopup[data-name='"+popupName+"']");
    $helpPopup.addClass("visible");
    $helpPopup.get(0).scrollTo(0, 0);
}


/*
//Test
setTimeout(() => {
    //showHelpPopup("su_srk_kesb");
    //showHelpPopup("kesb");
    showHelpPopup("fachstellen");
}, 1000);
*/